<template>
  <v-container>
    <v-card class="elevation-0">
      <v-card-title>
        Events Board
        <!-- <v-spacer></v-spacer>
        <v-text-field label="search" prepend-icon="search"></v-text-field> -->
      </v-card-title>
      <v-card-text>
        <div style="text-align:center" v-if="loading">
          <!-- <v-progress-circular indeterminate size="20"></v-progress-circular> -->
          <v-row>
            <v-col cols="12" xs="12" md="4" v-for="i in 6" v-bind:key="i">
              <v-skeleton-loader class="mx-auto" max-width="300" type="card"></v-skeleton-loader>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col cols="12" xs="12" sm="4" v-for="(ev,idx) in events" v-bind:key="idx">
            <EventItem :event_object="ev"></EventItem>
          </v-col>
        </v-row>
      </v-card-text>

    </v-card>

  </v-container>
</template>

<script>
// @ is an alias to /src
import EventItem from '@/components/EventItem.vue'
import { db } from '@/config/firebasedb';

export default {
  name: 'Home',
  components: {
    EventItem
  },
  data: () => ({
    show: false,
    events: [],
    sharedEvent: null
  }),
  async created() {
    this.loading = true;
    var eventsRef = db.collection("events")
    await eventsRef.onSnapshot(snap => {
      this.events = []
      snap.forEach((doc) => {
        var event = doc.data();
        var evDateLen = event.event_date.length
        event.id = doc.id;
        event.from_date = event.event_date[0];
        event.to_date = evDateLen == 2 ? event.event_date[1] : '';
        this.events.unshift(event);

      });
      this.loading = false;
    });
    // var sharedEventId = this.$route.query.share;
    // if(this.$route.query.share){
    //   this.sharedEvent = this.events.find(ev=>ev.id==sharedEventId)
    // }

  },
}
</script>
